<!--拼团列表-->
<template>
    <div>
        <van-pull-refresh v-model="loadingFresh" @refresh="onRefresh">
            <van-list
                    v-model="loadingMore"
                    :finished="noMore"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="row" v-for="(item,index) in list" @click="gotuanShare(item.order_id)">
                    <div class="goods-box">
                        <img class="goods-img" :src="item.pic_url" alt="">
                        <div class="goods-time" v-if="item.status==1">
                            <van-count-down
                                    :time="(item.last_time+1)*1000"
                                    format="仅剩 DD天 HH : mm : ss"
                            />
                        </div>
                        <div class="past-due flex-center" v-if="item.status==2 || item.status==3">
                            <img class="coupon-lose-img" src="../../../assets/newImg/icon-coupon-guoqi.png" alt="">>
                        </div>
                    </div>
                    <div class="goods-name">{{item.title}}</div>
                    <div class="row-price flex-between">
                        <div class="goods-detail flex-start">
                            <span class="goods-price">¥<span
                                    class="goods-price-num">{{item.pay_price}}</span></span>
                            <span class="goods-price-thr gray-light">¥{{item.order_price}}</span>
                            <span class="goods-tuan">还差{{item.total_member_count-item.member_count}}人成团</span>
                        </div>
                        <!--				<div class="gray-light sell-num">已售 31</div>-->
                    </div>
                </div>

            </van-list>
        </van-pull-refresh>
    </div>
</template>
<style scoped>
    .van-count-down {
        color: #fff;
        font-size: 12px;
        line-height: 0.5rem;
    }

    .van-count-down >>> span.sign {
        font-weight: 700;
        width: 10px;
    }
    .row {
        padding: 0.2rem;
    }

    .goods-box {
        width: 7.1rem;
        /*height: 3.06rem;*/
        position: relative;

    }

    .goods-img {
        width: 100%;
        /*height: 100%;*/
        height: 240px;
        border-radius: 5px;
        display: flex;
    }

    .goods-time {
        width: 2.91rem;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        background: rgba(0, 0, 0, 0.74);
        border-radius: 0rem 0.08rem 0rem 0.08rem;
        color: #fff;
        font-size: 12px;
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;

    }

    .goods-name {
        color: #333333;
        font-weight: 500;
        margin-top: 0.3rem;
    }

    .row-price {
        margin: 0.2rem 0;
    }

    .goods-price {
        color: #FD2840;
        font-size: 12px;
        font-weight: 700;
    }

    .goods-price-num {
        font-size: 17px;
    }

    .goods-price-thr {
        font-size: 12px;
        text-decoration: line-through;
        margin: 0 0.1rem;
    }

    .goods-tuan {
        height: 0.3rem;
        line-height: 0.3rem;
        padding: 0 5px;
        background: rgba(230, 247, 255, 1);
        border-radius: 0.04rem;
        border: 0.01rem solid rgba(9, 109, 217, 1);
        color: #096DD9;
        font-size: 9px;
    }

    .sell-num {
        font-size: 12px;
    }

    .past-due {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 5px;
    }

    .coupon-lose-img {
        width: 1.89rem;
        height: 1.41rem;
    }
</style>

<script>
    import {
        PullRefresh, List, CountDown
    } from 'vant';

    export default {
        name: 'TuanList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [ CountDown.name]:  CountDown,
        },
        data: function () {
            return {
                loadingFresh: false,
                loadingMore: false,
                noMore: false,
                params: {
                    p: 1,
                    step: 5,
                },
                list: [
                ],

            }
        },
        filter: {},
        mounted() {
            document.title = '我的拼团';
            this.fetch()
        },
        destroyed() {
        },
        methods: {
            fetch() {
                let that = this;
                this.$api.get('/api/tuan/myorderlist', that.params, (res) => {
                    that.loadingMore = false;

                    if (res.data.currentpage == 1) {
                        that.list = res.data.list
                        that.loadingFresh = false
                        // console.log(1)
                    } else {
                        let list = that.list.concat(res.data.list);
                        that.list = list
                    }
                    if (res.data.list.length == 0) {
                        that.noMore = true
                    }

                    this.params.p += 1;
                })
            },
            gotuanShare(id) {
                this.$router.push({
                    path: '/tuanshare',
                    query: {
                        id: id
                    }
                })
            },

            onLoad() {
                // console.log(1)
                // 异步更新数据
                if (this.params.p > 1) {
                    setTimeout(() => {
                        this.fetch()
                    }, 500);
                }


            },

            onRefresh() {
                let that = this;
                that.params.p = 1;
                that.fetch();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// TuanList.vue?c98b1c22